import { UserAvatar } from 'Components/shared/UserAvatar';
import { observer } from 'mobx-react';
import { SharedItemAuthorCellProps } from 'Modules/sharedItems/components/SharedItemAuthorCell/index.types';
import { useSharedItemAuthor } from 'Modules/sharedItems/hooks/useSharedItemAuthor';
import React from 'react';

export const SharedItemAuthorCell: React.FC<SharedItemAuthorCellProps> =
  observer(({ author }) => {
    const { displayName, avatarUrl, isInactive } = useSharedItemAuthor(author);
    const isKnownPerson = !!(author?.personId && author.personId > 0);

    return (
      <div className="flex min-w-0 items-center gap-[13px]">
        <UserAvatar
          name={displayName !== 'Unknown' ? displayName : undefined}
          presence={isKnownPerson ? null : undefined}
          isInactive={isInactive}
          image={avatarUrl}
        />
        <span
          className="truncate text-[14px]"
          {...(displayName !== 'Unknown' ? { 'data-private': true } : {})}
        >
          {displayName}
        </span>
      </div>
    );
  });
